module.exports = devowlWp_realQueue;